import * as Comlink from 'comlink';
import Vue from 'vue';
import { isWebView } from '../utils';
import { Workbox } from 'workbox-window';

try {
  if (window.SharedWorker && !isWebView()){
    const sharedWorker = new SharedWorker('@/utils/workers/app.worker.js', { 
      type: 'module', 
      name: 'appSharedWorker' 
    });
    Vue.prototype.$appSharedWorker = Comlink.wrap(sharedWorker.port);
  } else if (window.Worker){
    const worker = new Worker('@/utils/workers/app.worker.js', { 
      type: 'module', 
      name: 'appWorker' 
    });
    Vue.prototype.$appWorker = Comlink.wrap(worker);
  } else {
    window.console.log('No worker support');
  }
} catch (e) {
  window.console.log('SharedWorker create failed:', e);
  window.console.log('error message:', e.message);
}

/**
 * 是否注册sw
 * @type {boolean}
 */
const useSw = true;

/**
 * load service worker
 * 本地开发环境不启用serviceworker
 */
if ('serviceWorker' in window.navigator && process.env.NODE_ENV === 'production' && !isWebView() && useSw) {
  const wb = new Workbox(`${process.env.BASE_URL}/sw.js`.replace(/[/]+[/]/g, '/'));
  wb.register().then(() => {
    console.log('ServiceWorker Registered');
  }).catch((err) => {
    console.log('Service Worker Registered failed', err);
  });
}
